/**
 * Reusable PMS input with gray "PMS" prefix block attached — mirrors HexInput's
 * visual language so HEX and PMS fields align perfectly on the same row.
 */
export default function PmsInput({ value, onChange, testid }) {
  return (
    <label className="block cursor-text">
      <div className="flex items-stretch h-10 bg-white rounded-md border border-gray-200 focus-within:border-[var(--bh-accent,#fe7f57)] overflow-hidden transition-colors">
        <span className="w-12 flex items-center justify-center bg-gray-100 text-gray-400 text-sm font-mono select-none border-r border-gray-200 uppercase tracking-wide">
          PMS
        </span>
        <input
          data-testid={testid}
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          className="flex-1 min-w-0 px-3 text-sm bg-white focus:outline-none focus-visible:outline-none"
          placeholder=""
        />
      </div>
    </label>
  );
}
